import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionSelectorComponent } from './question-selector/question-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuestionCoreService } from './question-core.service';

@NgModule({
  declarations: [QuestionSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [QuestionCoreService],
  exports: [QuestionSelectorComponent],
})
export class QuestionCoreModule {}
